<div class="modal-header">
  <h5 class="modal-title" id="exampleModalLabel" i18n="@@ChangePasswordHeader">Passwort ändern</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>
<div class="modal-body">
  <app-message [service]="messageService"></app-message>

  <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">        
    <div class="mb-2">
      <label id="newpw" for="npw" i18n="@@NewPasswordLabel">Neues Passwort</label>
      <input id="newPassword" formControlName="newPassword" name="newPassword" type="password" class="form-control" placeholder="Neues Passwort" i18n-placeholder="@@NewPassword">
      <div class="error">
        <em *ngIf="formService.validateControl('newPassword') && formService.hasError('newPassword', 'required')" i18n="@@NewPasswordRequiredError">Neues Passwort wird benötigt</em>
      </div>
    </div>
    <div class="mb-2">
      <label id="newpwc" for="npwc" i18n="@@ConfirmNewPasswordLabel">Neues Passwort wiederholen</label>
      <input id="newPasswordConfirm" formControlName="newPasswordConfirm" name="newPasswordConfirm" type="password" class="form-control" placeholder="Neues Passwort wiederholen" i18n-placeholder="@@RepeatNewPassword">
      <div class="error">
        <em *ngIf="formService.validateControl('newPasswordConfirm') && formService.hasError('newPasswordConfirm', 'required')" i18n="@@ConfirmNewPasswordRequiredError">Neues Passwort muss wiederholt werden</em>
        <em *ngIf="formService.hasError('newPasswordConfirm', 'mustMatch')" i18n="@@PasswordsNotIdenticError">Passwörter müssen übereinstimmen</em>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" id="cancel" class="btn btn-yellow" (click)="onCancelClick()" data-bs-dismiss="modal" i18n="@@CancelButton">Abbrechen</button>
  <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
    <button type="submit" id="confirm" class="btn btn-yellow" [disabled]="!formService.form.valid" i18n="@@SavePasswordButton">Passwort ändern</button>
  </form>
</div>
